import { isTauri as detectTauri } from "@tauri-apps/api/core";

/**
 * True when the bundle is running inside the Tauri desktop shell.
 *
 * The check reads a flag the Tauri webview injects, so importing this module in
 * a plain browser is safe and simply returns false.
 */
export function isTauri(): boolean {
  try {
    return detectTauri();
  } catch {
    return false;
  }
}
